var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.768,
    height: 15,
    viewBox: "0 0 15.768 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "message",
    d: "M17.338,4.152c.43.843.43,1.947.43,4.155v.934a9.872,9.872,0,0,1-.159,2.541,3.942,3.942,0,0,1-2.673,2.673,9.872,9.872,0,0,1-2.541.159H11.91a3.942,3.942,0,0,0-2.245.72l-.042.03-2.058,1.47A.868.868,0,0,1,6.254,15.8a.868.868,0,0,0-.806-1.191H4.974A2.974,2.974,0,0,1,2,11.641V8.307C2,6.1,2,5,2.43,4.152A3.942,3.942,0,0,1,4.152,2.43C5,2,6.1,2,8.307,2h3.154c2.208,0,3.312,0,4.155.43A3.942,3.942,0,0,1,17.338,4.152ZM6.73,6.139a.591.591,0,1,0,0,1.183h6.307a.591.591,0,1,0,0-1.183ZM8.307,9.293a.591.591,0,1,0,0,1.183h3.154a.591.591,0,0,0,0-1.183Z",
    transform: "translate(-2 -2)",
    fill: "#3b56a7",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9415dfc5c11c4c7f716acf31a702c62f.svg";
export { ForwardRef as ReactComponent };